<template>
    <main class="grace-container">
        <section class="slogan">
            <div class="slogan-img"></div>
            <div class="main-title-wrapper">
                <div class="main-title">{{ $t('lp-zoho1') }}</div>
                <div class="main-subtitle">{{ $t('lp-zoho2') }}</div>
                <ul class="en-bullets">
                    <li>{{ $t('lp-zoho2-1') }}</li>
                    <li>{{ $t('lp-zoho2-2') }}</li>
                    <li>{{ $t('lp-zoho2-3') }}</li>
                </ul>

                <!--                <div class="contact-wrapper" v-if="!successMessageEn">-->
                <!--                    <v-flex>-->
                <!--                        <v-text-field :placeholder="$t('lp-zoho3')" v-model="userEmail" class="email-input" :rules="[rules.required, rules.emailValid]"></v-text-field>-->
                <!--                    </v-flex>-->

                <!--                    <v-btn class="submit-btn" text v-on:click="sendContact">{{ $t('lp-investor10') }}</v-btn>-->
                <!--                </div>-->
                <!--                <div class="contact-wrapper success-wrapper" v-else>-->
                <!--                    <div class="success-info">{{ $t('lp-zoho4') }}</div>-->
                <!--                </div>-->
                <iframe v-if="$i18n.locale === 'it'" frameborder="0" style="height:230px;border:none;" src='https://forms.zohopublic.eu/vindome/form/EnPrimeurCampaign2021Italianv2/formperma/xv9xIDJybiUhKH1XOJW5pLguFga-4B7TRf1CpdB3Kuc'></iframe>
                <iframe v-else frameborder="0" style="height:230px;border:none;" src='https://forms.zohopublic.eu/vindome/form/Test/formperma/ZZNBC7I1ayhut-iTJYkdQyv-poRS-1yHd8OLcqQ9--w'></iframe>
            </div>
        </section>

        <div class="why-invest-wrapper">
            <div class="container">
                <div class="collections-h1">{{ $t('en-primeur1') }}</div>
                <div class="card-text card-text2">{{ $t('en-primeur2') }}</div>
                <v-row>
                    <v-col class="col-md-4 right-half-padding">
                        <div class="how-icon primeur1">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('en-primeur3') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 right-half-padding left-half-padding">
                        <div class="how-icon primeur2">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('en-primeur4') }}</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 left-half-padding">
                        <div class="how-icon primeur3">
                            <div class="card-icon"></div>
                            <div class="card-text">{{ $t('en-primeur5') }}</div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="why-invest-wrapper">
            <div class="container">
                <h2 v-if="popularEnWines.length" class="home-title">{{ $t('latest-offers') }}</h2>
                <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>

                <a href="/trading-desk/EnPrimeur" class="browse-market-btn">{{ $t('popular-wines2') }}</a>
            </div>
        </div>
    </main>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';
    import axios from "axios";
    import {AMarket} from "@/store/actions";
    import {mapActions, mapGetters} from "vuex";
    import {GMarket} from "@/store/getters";
    import HomePopularWines from "@/components/home/HomePopularWines";

    export default {
        name: "LpEnPrimeur2021",
        head: {
            title: 'En Primeur fine wine investments | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-investor'
            }
        },
        validations: {
            userEmail: {
                required,
                email
            },
            firstName: {
                required
            },
            lastName: {
                required
            }
        },
        components: {
            HomePopularWines
        },
        computed: {
            popularEnWinesIds() {
                let _list = [];
                this.topEnWines.forEach(el => {
                    _list.push(el.wineId)
                });
                return _list
            },
            ...mapGetters({
                topWines: GMarket.GET_TOP_WINES,
                topEnWines: GMarket.GET_TOP_EN_WINES,
                wineItems: GMarket.GET_WINES
            })
        },
        data () {
            return {
                filtersObj: {
                    vintage: null,
                    countryId: null,
                    regionId: null,
                    appellationId: null,
                    producerId: null,
                    colorId: null,
                    priceFrom: null,
                    priceTo: null,
                    isEnPrimeur: true
                },
                popularEnWines: [],
                successMessageEn: false,
                userEmail: '',
                firstName: '',
                lastName: '',
                notes: '',
                errorMsg: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || this.$i18n.t('required-field'),
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || this.$i18n.t('invalid-email')
                }
            }
        },
        methods: {
            async sendContact () {
                if (this.userEmail && !this.$v.userEmail.$invalid) {
                    let contactCtrl = this;
                    let options = {
                        method: 'POST',
                        url: this.$i18n.locale === 'it' ? 'https://forms.raketa.cloud/submit/ZFc7Z-iptT' : 'https://forms.raketa.cloud/submit/aqM316-kmX',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json;charset=UTF-8'
                        },
                        data: {
                            data: {
                                firstName: 'FName',
                                lastName: 'LName',
                                email: this.userEmail
                            }
                        }
                    };
                    let response = await axios(options);
                    let responseOK = response && response.status === 200 && response.statusText === 'OK';
                    if (responseOK) {
                        contactCtrl.successMessageEn = true
                    }
                }
            },
            ...mapActions({
                getWines: AMarket.GET_WINES
            })
        },
        created() {
            this.getWines(this.filtersObj);
            this.$store.dispatch(AMarket.GET_TOP_EN_WINES).then(() => {
                let homeCtrl = this;
                if (this.wineItems.length) {
                    this.wineItems.forEach(wine => {
                        if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1) {
                            homeCtrl.popularEnWines.push(wine)
                        }
                    })
                } else {
                    setTimeout(() => {
                        this.wineItems.forEach(wine => {
                            if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1) {
                                homeCtrl.popularEnWines.push(wine)
                            }
                        })
                    }, 1000)
                }

            });
        }
    }
</script>

<style scoped>
    .browse-market-btn {
        background: #CEA94B;
        padding: 0 10px;
        width: 380px;
        height: 32px;
        line-height: 33px;
        border-radius: 4px;
        font-family: Roboto, sans-serif;
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        display: block;
        margin: 0 auto 40px;
        text-align: center;
        text-decoration: none;
    }
    .home-title {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 19px;
        line-height: 120%;
        color: #303030;
        margin-top: 48px;
    }
    .login-label {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        position: absolute;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 15px;
        color: #ffffff;
    }
    .submit-btn.v-btn {
        background: #E2C477;
        color: #FFF !important;
        min-width: 320px;
        height: 40px;
        font-weight: 700;
        font-size: 16px;
        line-height: 130%;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 18px auto 0;
        display: block;
        border-radius: 0;
    }
    .contact-wrapper {
        width: 320px;
        margin-top: 60px;
    }
    .contact-form-container {
        background: #F8F5F2;
    }
    .container {
        max-width: 1100px;
        margin: 0 auto;
    }
    .slogan {
        height: 672px;
        position: relative;
    }
    .slogan-img {
        background: url('../assets/landing/lp-main6.png') no-repeat center top;
        background-size: cover;
        width: 100%;
        height: 100%;
    }
    .main-title-wrapper {
        position: absolute;
        left: 56px;
        top: 135px;
    }
    .main-title {
        width: 1100px;
        height: 35px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 130%;
        display: block;
        color: #FFFFFF;
        margin-bottom: 20px;
    }
    .main-subtitle {
        width: 1100px;
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 22px;
        display: block;
        color: #FFFFFF;
        margin-bottom: 30px;
    }
    .en-bullets {
        list-style-position: outside;
    }
    .en-bullets li {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 21px;
        line-height: 22px;
        color: #FFFFFF;
        max-width: 565px;
    }
    h2 {
        color: #707070;
        margin-bottom: calc(2*var(--gutter));
    }

    .why-invest-wrapper {
        background: #ffffff;
        padding: 24px;
    }
    .collections-h1 {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 130%;
        text-align: center;
        color: #303030;
        margin-bottom: 35px;
    }
    .card-text {
        margin-bottom: 11px;
        text-align: center;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 130%;
    }
    .card-text2 {
        max-width: 800px;
        margin: -20px auto 20px;
    }
    .right-half-padding {
        padding-right: 25px;
    }
    .left-half-padding {
        padding-left: 25px;
    }
    .card-icon {
        height: 80px;
        width: 100%;
        margin-bottom: 20px;
    }
    .primeur1 .card-icon {
        background: url('../assets/home/price.png') no-repeat center center;
        background-size: contain;
    }
    .primeur2 .card-icon {
        background: url('../assets/home/chart.png') no-repeat center center;
        background-size: contain;
    }
    .primeur3 .card-icon {
        background: url('../assets/home/lock.png') no-repeat center center;
        background-size: contain;
    }
    .success-wrapper {
        text-align: center;
        background: url('../assets/success_icon.png') no-repeat center 30px;
        padding: 140px 32px 32px;
    }
    .success-info {
        color: #ffffff;
    }
    .done-btn {
        background: #E1C376 !important;
        color: #FFF !important;
        margin-top: 30px;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
    }

    @media (max-width: 767px) {
        .browse-market-btn {
            width: 100%;
            margin-bottom: 10px;
            margin-top: 20px
        }
        .main-title {
            font-weight: 700;
            font-size: 23px;
            line-height: 30px;
            text-align: center;
            max-width: 100%;
            height: auto;
        }
        .main-subtitle {
            max-width: 100%;
            font-weight: 400;
            font-size: 18px;
            line-height: 21px;
            height: auto;
            margin-bottom: 10px;
            padding: 0 15px;
        }
        .main-title-wrapper {
            top: 80px;
            width: 100%;
            left: 0;
        }
        .contact-wrapper {
            margin: 60px auto 0;
        }
    }
</style>
<style>
    .page-landing-investor .swiper-container {
        height: 400px;
    }
    .page-landing-investor .v-main {
        padding-top: 0 !important;
    }
    .page-landing-investor .logo {
        display: block;
        margin: 0 auto;
        width: 206px;
    }
    .page-landing-investor .logo img {
        margin-top: 30px;
        width: 206px;
        height: 45px;
    }
    .page-landing-investor .theme--dark.v-sheet.header-toolbar.v-app-bar--is-scrolled .logo img {
        margin-top: 10px;
    }
    .page-landing-investor .nav-second-row,
    .page-landing-investor .nav-first-row-right {
        display: none;
    }
    .contact-wrapper .flex {
        margin-top: 20px;
        text-align: left;
    }
    .contact-wrapper .v-input input {
        height: 40px;
        max-height: unset;
        margin-top: 5px;
        padding-left: 15px;
        border-bottom: 1px solid #B2B2B2;
    }

    .contact-form-container .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: 0;
    }

    @media (max-width: 767px) {
        .page-landing-grace .theme--dark.v-sheet.header-toolbar,
        .page-landing-grace .theme--dark.v-sheet.header-toolbar .v-toolbar__content {
            height: 40px !important;
        }
        .page-landing-investor .v-application .hidden-md-and-up {
            display: none !important;
        }
        .page-landing-investor .logo,
        .page-landing-investor .logo img {
            width: 106px;
            margin: 0;
        }
        .page-landing-investor .logo {
            margin: 15px auto 0;
        }
        .why-invest-wrapper .row {
            display: block;
        }
        .why-invest-wrapper .col {
            width: 100%;
            display: block;
        }
    }
</style>
